/**
 * The enrolment surfaces' English copy. `host` is the address the passkey is
 * bound to — the relying-party id — so the copy states which site it serves.
 * Neither catalog addresses the reader: the views ship to a product that
 * says Sie and one that says Du.
 */
export const en = {
  heading: {
    offer: (host: string) => `Skip the code on ${host}`,
    done: 'Passkey set up',
  },
  body: 'Face, fingerprint or PIN signs in instead. The scan never leaves this device.',
  status: {
    // A non-breaking space holds the line, so the actions never move.
    idle: ' ',
    working: 'Follow the prompt from this device.',
    done: (host: string) => `The next sign-in to ${host} needs no code.`,
    error: "That didn't finish — nothing was saved.",
  },
  action: {
    idle: 'Set up a passkey',
    working: 'Set up a passkey',
    done: 'Done',
    error: 'Try again',
  },
  decline: 'Not now',
  row: {
    idle: 'No passkey on this device',
    working: 'Confirm on this device',
    done: (host: string) => `Passkey ready for ${host}`,
    error: "Didn't finish — nothing changed",
  },
  rowAction: {
    idle: 'Set up',
    working: 'Set up',
    done: 'Replace',
    error: 'Try again',
  },
  redo: {
    title: 'Set up a new passkey?',
    body: (host: string) =>
      `This device already has one for ${host}. A new one replaces the one it offers first.`,
    confirm: 'Set up a new passkey',
    cancel: 'Cancel',
  },
  ariaLabel: (host: string) => `Set up a passkey for ${host}`,
};

export type PasskeyCatalog = typeof en;
